import React from 'react';
import Modal from './Modal.js';
import loading_gif from '../Images/loading.gif';
import './EditPubPage.css';

class EditPubPage extends React.Component {
	constructor(props) {
		super(props);
				
		// State management:
		if (this.props.location.state) { // Allow stateful linking
			this.state = this.props.location.state;
		}
		else {
			this.state = {
				isLoaded: false,
				error: null,
				pubTypesList: [],
				OrgSitesList: [],
				allSitesList: [],
				authors: [{lastName: '', firstName: '', middleName: ''}],
				publicationEvent: '',
				publishedDate: '',
				dateStyle: 'MDY',
				publicationTypeId: 0,
				attendees: 0,
				title: '',
				status: -1,
				sites: [],
				origin: 'Internal',
				share: 'true',
				tracking: 'false',
				showAbstractBox: false,
				abstractText: '',
				showArtifactBox: false,
				artifactUrl: null,
				editPubModal: null
			};
		}
		
		// Function bindings:
		this.fetchData = this.fetchData.bind(this);
		this.addAuthor = this.addAuthor.bind(this);
		this.removeAuthor = this.removeAuthor.bind(this);
		this.updateAuthorLast = this.updateAuthorLast.bind(this);
		this.updateAuthorFirst = this.updateAuthorFirst.bind(this);
		this.updateAuthorMiddle = this.updateAuthorMiddle.bind(this);
		this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
		this.handlePublicationEventChange = this.handlePublicationEventChange.bind(this);
		this.handlePublicationTypeChange = this.handlePublicationTypeChange.bind(this);
		this.handleTitleChange = this.handleTitleChange.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleDateStyleOptionChange = this.handleDateStyleOptionChange.bind(this);
		this.handleStatusOptionChange = this.handleStatusOptionChange.bind(this);
		this.handleSiteOptionChange = this.handleSiteOptionChange.bind(this);
		this.handleOriginOptionChange = this.handleOriginOptionChange.bind(this);
		this.handleShareOptionChange = this.handleShareOptionChange.bind(this);
		this.handleTrackingOptionChange = this.handleTrackingOptionChange.bind(this);
		this.handleAbstractOptionChange = this.handleAbstractOptionChange.bind(this);
		this.handleAbstractValueChange = this.handleAbstractValueChange.bind(this);
		this.handleArtifactOptionChange = this.handleArtifactOptionChange.bind(this);
		this.updateArtifactUrl = this.updateArtifactUrl.bind(this);
		this.verifySubmit = this.verifySubmit.bind(this);
	}
	
	// Get necessary initial values from server
	fetchData() {
		// Populate current publication data from imported state
		this.setState({
			id: this.state.pubData.id,
			authors: JSON.parse(JSON.stringify(this.state.pubData.authors)),
			sites: this.state.pubData.sites.map((site) => { return site.site.id; }),
			publicationEvent: this.state.pubData.publicationEvent || '',
			publishedDate: new Date(this.state.pubData.publishedDate).toISOString().split('T')[0],
			publicationTypeId: this.state.pubData.publicationTypeId,
			dateStyle: this.state.pubData.datestyle,
			attendees: this.state.pubData.attendees,
			title: this.state.pubData.title || '',
			status: this.state.pubData.status,
			origin: this.state.pubData.origin,
			share: this.state.pubData.share ? 'true' : 'false',
			tracking: this.state.pubData.tracking ? 'true' : 'false',
			showAbstractBox: this.state.pubData.abstractText ? true : false,
			abstractText: this.state.pubData.abstractText,
			showArtifactBox: this.state.pubData.artifactUrl ? true : false,
			artifactUrl: this.state.pubData.artifactUrl,
		});
		if (this.props.userData && this.props.activeOrg) { // Make sure our props exist
			let urls = [
				'/webpub-services/publicationTypesAPI/getAllPublicationTypes'
			];
			
			// Sites that user has access to
			urls.push('/webpub-services/siteAPI/getSitesByOrganization/' + this.props.activeOrg);
			
			// Asynchronously retrieve all our stuff in one clump
			Promise.all(
				urls.map((url) => {
					return fetch(url).then(res => res.json())
				}
			))
			.then((data) => { // Everything is resolved at this point. Process it.
				// Process types
				const typesResult = data[0];
				if (typesResult.length && typesResult[0].typeName) { // Results look like we expect
					this.setState({
						pubTypesList: typesResult
					});
				}
				else { // Something went wrong. Give up.
					this.setState({
						error: {message: 'PublicationTypes results malformed. (EPP69)'} // Most exciting error code so far
					});
					return;
				}
				
				let siteList = [];
				
				data.map((resultSet, idx) => {
					if (idx > 0) { // We already processed that one
						resultSet.map((site) => {
							siteList.push(site);
							
							return true;
						});
					}
					
					return true;
				});
				
				let selectedList = this.state.pubData.sites.map((site) => { return site.site.id; });
				let totalSiteList = siteList.filter((site) => !selectedList.includes(site.id));
				this.state.pubData.sites.map((pubSite) => {
					totalSiteList.push(pubSite.site);
					
					return true;
				});
				
				// If we have reached this point, all our calls were successful. Congratulations!
				this.setState({
					isLoaded: true,
					error: null,
					OrgSitesList: siteList,
					allSitesList: totalSiteList
				});
			});
		}
	}
	
	// Increase the number of Author inputs
	addAuthor() {
		this.setState((prevState) => ({
			authors: [...prevState.authors, {lastName: '', firstName: '', middleName: ''}]
		}));
	}
	
	// Decrease the number of Author inputs
	removeAuthor() {
		let authorList = this.state.authors;
		if (authorList.length > 1) { // Can't delete the last one
			authorList.pop();
		
			this.setState({
				authors: authorList
			});
		}
	}
	
	// Update Author array based on user interaction
	updateAuthorLast(changeEvent) {
		let newAuthors = this.state.authors;
		newAuthors[parseInt(changeEvent.target.id)].lastName = changeEvent.target.value;
		this.setState({
			authors: newAuthors
		});
	}
	
	// Update Author array based on user interaction
	updateAuthorFirst(changeEvent) {
		let newAuthors = this.state.authors;
		newAuthors[parseInt(changeEvent.target.id)].firstName = changeEvent.target.value;
		this.setState({
			authors: newAuthors
		});
	}
	
	// Update Author array based on user interaction
	updateAuthorMiddle(changeEvent) {
		let newAuthors = this.state.authors;
		newAuthors[parseInt(changeEvent.target.id)].middleName = changeEvent.target.value;
		this.setState({
			authors: newAuthors
		});
	}
	
	// Track attendees
	handleAttendeesChange(changeEvent) {
		if (parseInt(changeEvent.target.value) >= 0 && parseInt(changeEvent.target.value) < 2000000) {
			this.setState({
				attendees: parseInt(changeEvent.target.value)
			});
		}
		else {
			this.setState({
				attendees: 0
			});
		}
	}
	
	// Update publicationEvent
	handlePublicationEventChange(changeEvent) {
		this.setState({
			publicationEvent: changeEvent.target.value
		});
	}
	
	// Update publicationTypeId
	handlePublicationTypeChange(changeEvent) {
		if (changeEvent.target.value !== '') {
			this.setState({
				publicationTypeId: changeEvent.target.value
			});
		}
		else {
			this.setState({
				publicationTypeId: 0
			})
		}
	}
	
	// Update title
	handleTitleChange(changeEvent) {
		this.setState({
			title: changeEvent.target.value
		});
	}
	
	// Record user's Status selection
	handleStatusOptionChange(changeEvent) {
		if (changeEvent.target.value !== '') {
			this.setState({
				status: changeEvent.target.value
			});
		}
		else {
			this.setState({
				status: -1
			})
		}
	}
	
	// Record date changes
	handleDateChange(changeEvent) {
		if (changeEvent.target.validationMessage.length > 1) { // Lean on HTML validator
			return;
		}
		this.setState({
			publishedDate: changeEvent.target.value
		});
	}
	
	// Record user's dateStyle selection
	handleDateStyleOptionChange(changeEvent) {
		this.setState({
			dateStyle: changeEvent.target.value
		});
	}
	
	// Change list of to-post sites
	handleSiteOptionChange(changeEvent) {
		let newSiteList = this.state.sites;
		if (newSiteList.includes(parseInt(changeEvent.target.id))) {
			newSiteList = newSiteList.filter((item) => item !== parseInt(changeEvent.target.id));
		}
		else {
			newSiteList.push(parseInt(changeEvent.target.id));
		}
		
		this.setState({
			sites: newSiteList
		});
	}
	
	// Record user's origin selection
	handleOriginOptionChange(changeEvent) {
		this.setState({
			origin: changeEvent.target.value
		});
	}
	
	// Record user's share selection
	handleShareOptionChange(changeEvent) {
		if (changeEvent.target.value === 'false') { // Clear non-org site selections
			const orgSitesOnly = this.state.OrgSitesList.map((orgSite) => {
				return this.state.sites.includes(orgSite.id)
					? orgSite.id
					: null;
			});
			
			// Actually, verify with user that they meant to do that
			const newModal = (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='edit-pub-modal'>
							<header>
								<span>Warning</span>
								<button
									onClick={
										() => {
											this.setState({
												tracking: 'false',
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
								<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
									If you remove the Share attribute, this publication will be un-shared from
									ALL sites outside your organizations.
									If that isn't what you meant to do, select Cancel. Otherwise, select Confirm.
								</div>
							<footer>
								<button
									onClick={
										() => {
											this.setState({
												share: 'false',
												sites: orgSitesOnly,
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='confirm'
								>
									Confirm
								</button>
								<button 
									onClick={
										() => {
											this.setState({
												share: 'true',
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='cancel' 
								>
									Cancel
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			);
			
			this.setState({
				editPubModal: newModal
			});
		} 
		else {
			this.setState({
				share: changeEvent.target.value
			});
		}
	}
	
	// Show/hide Abstract box based on user selection
	handleAbstractOptionChange(changeEvent) {
		this.setState((prevState, props) => ({
			showAbstractBox: !prevState.showAbstractBox,
			abstractText: ''
		}));
	}
	
	// Handle Artifact Link radio button change
	handleArtifactOptionChange(changeEvent) {
		// Show Right To Post modal for Yes
		const newModal = this.state.showArtifactBox
		? null
		: (
			<Modal>
				<div className='modal' aria-modal='true'>
					<div role='dialog' className='edit-pub-modal'>
						<header>
							<span>Right To Post</span>
							<button
								onClick={
									() => {
										this.setState({
											showArtifactBox: false,
											artifactUrl: null,
											editPubModal: null
										});
									}
								}
								type='button'
								aria-label='close'
							>
								X
							</button>
						</header>
							<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
								By clicking the 'Confirm' button below, you verify that you have the legal
								right to share this link. <br />
								DO NOT post links to personally-identifying data.
							</div>
						<footer>
							<button
								onClick={
									() => {
										this.setState({
											showArtifactBox: true,
											editPubModal: null
										});
									}
								}
								type='button'
								aria-label='confirm'
							>
								Confirm
							</button>
							<button 
								onClick={
									() => {
										this.setState({
											showArtifactBox: false,
											artifactUrl: null,
											editPubModal: null
										});
									}
								}
								type='button'
								aria-label='cancel' 
							>
								Cancel
							</button>
						</footer>
					</div>
				</div>
			</Modal>
		);
		
		this.setState((prevState, props) => ({
			showArtifactBox: !prevState.showArtifactBox,
			editPubModal: newModal,
			artifactUrl: null
		}));
	}
	
	// Record user's Abstract text
	handleAbstractValueChange(changeEvent) {
		this.setState({
			abstractText: changeEvent.target.value
		});
	}
	
	// Record user's Artifact text
	updateArtifactUrl(changeEvent) {
		this.setState({
			artifactUrl: changeEvent.target.value
		});
	}
	
	// Record user's tracking selection
	handleTrackingOptionChange(changeEvent) {
		if (changeEvent.target.value === 'true') { // Clear site selections
			// Actually, verify with user that they meant to do that
			const newModal = (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='edit-pub-modal'>
							<header>
								<span>Warning</span>
								<button
									onClick={
										() => {
											this.setState({
												tracking: 'false',
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
								<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
									Changing this item to Tracking Only will unpublish it from ALL 
									sites! If that isn't what you meant to do, select Cancel. Otherwise, select Confirm.
								</div>
							<footer>
								<button
									onClick={
										() => {
											this.setState({
												tracking: 'true',
												sites: [],
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='confirm'
								>
									Confirm
								</button>
								<button 
									onClick={
										() => {
											this.setState({
												tracking: 'false',
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='cancel' 
								>
									Cancel
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			);
			
			this.setState({
				editPubModal: newModal
			});
		} 
		else {
			this.setState({
				tracking: 'false'
			});
		}
	}
	
	// Verify that user has actually done the work to submit stuff
	// Users can't be trusted, after all
	verifySubmit() {
		let thisSubmission = {
			id: this.state.pubData.id,
			approved: this.state.pubData.approved,
			createdDate: this.state.pubData.createdDate,
			createdUser: this.state.pubData.createdUser,
			modifiedDate: new Date(),
			modifiedUser: this.props.userData.id,
			organizationId: this.state.pubData.organizationId,
			attendees: this.state.attendees,
			datestyle: this.state.dateStyle,
			origin: this.state.origin,
			share: (this.state.share === 'true') ? true : false
		};
		
		let acceptableSubmission = true;  // Trust
		let unacceptableSubmissionReason = []; // but verify
		
		// Verify pub data
		let authorList = this.state.authors.filter((authorObj) => authorObj.lastName && authorObj.lastName.length > 1);
		if (authorList.length < 1) {
			acceptableSubmission = false;
			unacceptableSubmissionReason.push('Must enter at least one author');
		}
		else {
			let firstAuthor = authorList.sort((a, b) => {return a.lastName.localeCompare(b.lastName);})[0];
			thisSubmission.firstAuthor = firstAuthor.lastName;
		}
		
		let siteList = this.state.sites;
		if (this.state.tracking === 'true') {
			thisSubmission.tracking = true;
			if (siteList.length) {
				acceptableSubmission = false;
				unacceptableSubmissionReason.push('Cannot publish Tracking Only publication to Sites');
			}
		}
		else {
			thisSubmission.tracking = false;
		}
		
		if ( // Date must be real. No fakedates.
			this.state.publishedDate === ''
			|| this.state.publishedDate === null
			|| isNaN(parseInt(this.state.publishedDate))
			|| parseInt(this.state.publishedDate) < 1
			|| parseInt(this.state.publishedDate) > 9999
		) {
			acceptableSubmission = false;
			unacceptableSubmissionReason.push('Must enter an acceptable date');
		}
		else {
			let publishedDate = new Date(this.state.publishedDate + ' 12:00:00'); // Noon of the selected day.
			thisSubmission.publishedDate = publishedDate;
		}
		
		if (this.state.abstractText && this.state.abstractText.length) {
			thisSubmission.abstractText = this.state.abstractText;
		}
		else {
			thisSubmission.abstractText = null;
		}
		
		if (this.state.showArtifactBox && this.state.artifactUrl && this.state.artifactUrl.length) {
			thisSubmission.artifactUrl = this.state.artifactUrl;
		}
		
		if (this.state.publicationEvent && this.state.publicationEvent.length) {
			thisSubmission.publicationEvent = this.state.publicationEvent;
		}
		
		if (this.state.title && this.state.title.length) {
			thisSubmission.title = this.state.title;
		}
		else {
			acceptableSubmission = false;
			unacceptableSubmissionReason.push('Must enter a Title');
		}
		
		if (this.state.publicationTypeId) {
			thisSubmission.publicationTypeId = this.state.publicationTypeId;
		}
		else {
			acceptableSubmission = false;
			unacceptableSubmissionReason.push('Must select valid Type');
		}
		
		if (this.state.status >= 0) {
			thisSubmission.status = this.state.status;
		}
		else {
			thisSubmission.status = null;
		}
		
		if (!acceptableSubmission) {
			const submissionModal = (
				<Modal>
					<div className='modal' aria-modal='true'>
						<div role='dialog' className='edit-pub-modal'>
							<header>
								<span>Unacceptable Submission</span>
								<button className='edit-pub-popup-button'
									onClick={
										() => {
											this.setState({
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='close'
								>
									X
								</button>
							</header>
								<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
									The data you have submitted is incomplete. <br />
									The reason(s) returned were: <br />
									{ unacceptableSubmissionReason.map(reason => {
											return <div key={'reason-' + reason}>{reason}</div>;
										}) 
									} <br />
									Please resolve these issues and try again.
								</div>
							<footer>
								<button
									onClick={
										() => {
											this.setState({
												editPubModal: null
											});
										}
									}
									type='button'
									aria-label='close'
								>
									Close
								</button>
							</footer>
						</div>
					</div>
				</Modal>
			);
			
			this.setState({
				editPubModal: submissionModal
			});
			
			return;
		}
		
		// Congratulations! If this is being executed, nothing was flagged as unacceptable in your data!
		
		// Update Publication
		fetch('/webpub-services/publicationAPI/updatePublication', 
			{
				method: 'PUT',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(thisSubmission)
			}
		)
		.then(res => res.json())
		.then(
			(result) => {
				if (result.id > 0) {
					const publicationId = result.id;
					
					// PublicationAuthor promise arrays
					let authorsToUpdate = [];
					let authorsToDelete = this.state.pubData.authors.map((oldAuthor) => {
						let newAuthor = authorList.filter((listedAuthor) => listedAuthor.id && listedAuthor.id === oldAuthor.id);
						if (newAuthor.length < 1) {
							// This was in the list, but is no longer in the list. This should be deleted.
							return oldAuthor;
						}
						else { // This was in the list and still is in the list.
							if (
								oldAuthor.lastName !== newAuthor[0].lastName
								|| oldAuthor.firstName !== newAuthor[0].firstName
								|| oldAuthor.middleName !== newAuthor[0].middleName
							) {
								// The name has changed. This should be updated.
								authorsToUpdate.push(newAuthor[0]);
							}
							
							return null;
						}
					}).filter(item => item !== null);
					let authorsToCreate = authorList.filter((author) => !author.id);
					
					let authorUpdatePromises = authorsToUpdate.map((authorObj) => {
						let authorFetchPromise = fetch(
							'/webpub-services/publicationAuthorAPI/updatePublicationAuthor',
								{
									method: 'PUT',
									headers: {
										Accept: 'application/json',
										'Content-Type': 'application/json'
									},
									body: JSON.stringify(authorObj)
								}
						)
						.then(res => res.json());
							
						return authorFetchPromise;
					});
					let authorDeletePromises = authorsToDelete.map((authorObj) => {
						let authorFetchPromise = fetch(
							'/webpub-services/publicationAuthorAPI/deletePublicationAuthor' + authorObj.id,
								{
									method: 'DELETE'
								}
						)
						.then(res => res.json());
							
						return authorFetchPromise;
					});
					let authorCreatePromises = authorsToCreate.map((authorObj) => {
							authorObj.publicationId = publicationId;
							
							let authorFetchPromise = fetch(
								'/webpub-services/publicationAuthorAPI/createPublicationAuthor',
								{
									method: 'POST',
									headers: {
										Accept: 'application/json',
										'Content-Type': 'application/json'
									},
									body: JSON.stringify(authorObj)
								}
							)
							.then(res => res.json());
							
							return authorFetchPromise;
						}
					);
					
					// PublicationSite promise arrays
					
					// Get old sites to delete
					let sitesToDelete = this.state.pubData.sites.filter((oldSite) => !siteList.includes(oldSite.siteId));
					// Get new sites to create
					let oldSites = this.state.pubData.sites.map((site) => { return site.site.id; });
					let sitesToCreate = siteList.filter((newSite) => !oldSites.includes(newSite));
					
					let siteCreatePromises = sitesToCreate.map((siteId) => {
							let siteFetchPromise = fetch(
								'/webpub-services/publicationSiteAPI/createPublicationSite',
								{
									method: 'POST',
									headers: {
										Accept: 'application/json',
										'Content-Type': 'application/json'
									},
									body: JSON.stringify({ siteId: siteId, publicationId: publicationId })
								}
							)
							.then(res => res.json());
							
							return siteFetchPromise;
						}
					);
					let siteDeletePromises = sitesToDelete.map((site) => {
							let siteFetchPromise = fetch(
								'/webpub-services/publicationSiteAPI/deletePublicationSiteById/' + site.id,
								{
									method: 'DELETE'
								}
							)
							.then(res => res.json());
							
							return siteFetchPromise;
						}
					);
					
					// Create authorSites, publicationSites
					Promise.all(
						[authorCreatePromises, authorDeletePromises, authorUpdatePromises, siteCreatePromises, siteDeletePromises]
					)
					.then(
						(result) =>  {
							this.props.history.push("/masterpool");
						}
					);
					// Everything is resolved at this point. Great!
					// Notify users of changed publication
					fetch('/webpub-services/WPUserOrganizationAPI/getWPUserOrganizationByOrganizationid/' + this.props.activeOrg, 
						{
							method: 'GET'
						}
					)
					.then(res => res.json())
					.then(
						(orgList) => {
							const usersToNotify = orgList.filter(f => f.accessLevel >= 2).map(m => m.wPUser.email);
							fetch('/webpub-services/publicationAPI/notifyPubChange',
							{
								method: 'PUT',
								headers: {
									Accept: 'application/json',
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({
									usersToNotify: usersToNotify.join(),
									changedPubId: result.id,
									changedPubTitle: result.title
								})
							}
							);
  					},
						(error) => {
							alert("Unable to get list of users " + JSON.stringify(error));
						}
					);
				}
				else {
					// Something went wrong. Inform the user.
					const submissionModal = (
						<Modal>
							<div className='modal' aria-modal='true'>
								<div role='dialog' className='edit-pub-modal'>
									<header>
										<span>Submission not Processed</span>
										<button
											onClick={
												() => {
													this.setState({
														editPubModal: null
													});
												}
											}
											type='button'
											aria-label='close'
										>
											X
										</button>
									</header>
										<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
											The publication was not created. <br />
											The server returned this information: <br />
											{result.status + ': "' + result.error + '". "' + result.message + '". '}
										</div>
									<footer>
										<button
											onClick={
												() => {
													this.setState({
														editPubModal: null
													});
												}
											}
											type='button'
											aria-label='close'
										>
											Close
										</button>
									</footer>
								</div>
							</div>
						</Modal>
					);
					
					this.setState({
						editPubModal: submissionModal
					});
				}
			},
				
			(error) => {
				// Something went wrong. Inform the user.
				
				const submissionModal = (
					<Modal>
						<div className='modal' aria-modal='true'>
							<div role='dialog' className='edit-pub-modal'>
								<header>
									<span>Submission not Processed</span>
									<button
										onClick={
											() => {
												this.setState({
													editPubModal: null
												});
											}
										}
										type='button'
										aria-label='close'
									>
										X
									</button>
								</header>
									<div className='edit-pub-modal-content' style={{textAlign: 'center'}} >
										The publication was not created. <br />
										{
											error.message 
												? 'The server returned this message: "' + error.message + '". ' 
												: 'An unknown error occurred. (EPP610)'
										}
									</div>
								<footer>
									<button
										onClick={
											() => {
												this.setState({
													editPubModal: null
												});
											}
										}
										type='button'
										aria-label='close'
									>
										Close
									</button>
								</footer>
							</div>
						</div>
					</Modal>
				);
				
				this.setState({
					editPubModal: submissionModal
				});
			}
		);
	}
	
	// Initial page load
	componentDidMount() {
		if (this.state.pubData && this.state.pubData.id) {
			this.fetchData();
		}
		else {
			this.setState({
				error: {message: 'No Publication ID detected. (EPP664)'}
			});
		}
	}
	
	render() {
		// Sanity checking
		if (this.state.error) {
			return <div className='error-text'>
				Error: {
					this.state.error.message 
					? this.state.error.message 
					: 'An unknown error has occurred (EPP83)'
				}
			</div>;
		} 
		else if (!this.state.isLoaded) { // Display nothing until we're ready for user input
			return <div>Loading <img src={loading_gif} alt='loading gif' style={{ verticalAlign: 'middle' }} /></div>;
		}
		
		const adminOrgs = this.props.userData.permissions.map((org) => {
			if (org.accessLevel >= 2) { // 0 is no access, 1 is read/submit, 2 is admin, 3 is a super-admin
				return org.organizationId;
			}
			else {
				return null;
			}
		}).filter(item => item !== null);
		
		const canEdit = 
			(
				this.props.userData.id === this.state.pubData.createdUser 
				|| adminOrgs.includes(this.state.pubData.organizationId)
			) 
			&& parseInt(this.props.activeOrg) === parseInt(this.state.pubData.organizationId)
			? true
			: false;
		
		// Use {requiredStar} to mark required fields
		const requiredStar = <span style={{ color: 'red' }} > *</span>;
		
		const statusCodes = ['Planned', 'Submitted', 'In Review', 'In Press', 'Published'];
		
		// Put it all together:
		return (
			<div>
				<h2>New Publication: Add, Post, and Edit</h2>
				<p><i>
					WebPub is used by AAI to track all artifacts produced by staff and develop reports. 
					WebPub is also used to post and share publications across AAI projects and websites. 
					Artifacts produced or co-produced as an AAI employee should be regularly reported according 
					to your organization’s procedures and policies.  Optionally, artifacts that are part of 
					academic studies relevant to AAI’s mission may be reported.  WebPub is also used to post 
					and share non-AAI artifacts marked as external to AAI websites.
				</i></p>
				<div className='column-container'>
					<div className='column column-one'>
						<label 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Author(s) {requiredStar} 
						</label>
						{
							this.state.authors.map((author, idx) => {
								return (
									<div key={'authorInput-' + idx} >
										<input 
											id={idx} 
											name={idx}
											type='text'
											maxLength={50}
											value={author.lastName || ''}
											onChange={this.updateAuthorLast}
											style={{ paddingRight: '1%', maxWidth: '40%' }}
											placeholder='Last Name/Entity'
											disabled={!canEdit}
										/>
										<input 
											id={idx} 
											name={idx}
											type='text'
											maxLength={50}
											value={author.firstName || ''}
											onChange={this.updateAuthorFirst}
											style={{ paddingRight: '1%', maxWidth: '25%' }}
											placeholder='First Name'
											disabled={!canEdit}
										/>
										<input 
											id={idx} 
											name={idx}
											type='text'
											maxLength={50}
											value={author.middleName || ''}
											onChange={this.updateAuthorMiddle}
											style={{ paddingRight: '1%', maxWidth: '25%' }}
											placeholder='Middle Name'
											disabled={!canEdit}
										/>
									</div>
								);
							})
						}
						{
							canEdit
							? <div>
								<span 
									className='ui-icon icon-filled-minus tooltip' 
									onClick={this.removeAuthor}
								>
									<span className='tooltiptext-bottom'>Remove Author</span>
								</span>
								<span 
									className='ui-icon icon-filled-plus tooltip' 
									onClick={this.addAuthor}
								>
									<span className='tooltiptext-bottom'>Add Author</span>
								</span>
							</div>
							: null
						}
						<br />
						<br />
						<label 
							htmlFor='publishedDateInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Date {requiredStar} 
						</label>
						<input 
							type='date'
							value={this.state.publishedDate}
							onChange={this.handleDateChange}
							disabled={!canEdit}
							max='2899-12-31' // 9999 and 2999 crashed Edge on Stoney's laptop. Microsoft, man. 
							min='0001-01-01'
						/>
						<br />
						<br />
						<label 
							htmlFor='attendeesInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Attendees 
						</label>
						<input 
							type='number'
							min={0}
							max={2000000}
							value={this.state.attendees}
							onChange={this.handleAttendeesChange}
							disabled={!canEdit}
						/>
					</div>
					<div className='column column-two'>
						<label 
							htmlFor='titleInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Title {requiredStar} 
						</label>
						<input 
							id='titleInput'
							type='text'
							maxLength={200}
							value={this.state.title}
							onChange={this.handleTitleChange}
							disabled={!canEdit}
						/>
						<br />
						<br />
						<br />
						<label 
							htmlFor='dateStyleInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Date Display {requiredStar} 
						</label>
							<input 
								type='radio' 
								id='MDY' 
								name='dateStyleInput' 
								value='MDY'
								checked={this.state.dateStyle === 'MDY'}
								onChange={this.handleDateStyleOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='MDY' style={{ marginRight: 5 }} >mm/dd/yyyy</label>
							
							<input  
								type='radio'  
								id='MY'  
								name='dateStyleInput'  
								value='MY' 
								checked={this.state.dateStyle === 'MY'}
								onChange={this.handleDateStyleOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='MY' style={{ marginRight: 5 }} >mm/yyyy</label>
							
							<input  
								type='radio'  
								id='YYYY'  
								name='dateStyleInput'  
								value='YYYY' 
								checked={this.state.dateStyle === 'YYYY'}
								onChange={this.handleDateStyleOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='YYYY' style={{ marginRight: 5 }} >yyyy</label>
						<br />
						<br />
						<label 
							htmlFor='statusInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Status 
						</label>
						<select
							name='statusInput'
							value={this.state.status}
							onChange={this.handleStatusOptionChange}
							disabled={!canEdit}
						>
							<option value='' >[Select]</option>
							{
								statusCodes.map((name, idx) => {
									return <option value={idx} key={'status-' + idx} >{name}</option>;
								})
							}
						</select>
					</div>
					<div className='column column-three'>
						<label 
							htmlFor='publicationTypeIdInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Type {requiredStar} 
						</label>
						<select
							id='publicationTypeIdInput'
							name='publicationTypeId'
							value={this.state.publicationTypeId}
							onChange={this.handlePublicationTypeChange}
							disabled={!canEdit}
						>
							<option value='' >[Select]</option>
							{
								this.state.pubTypesList.map((code) => {
									return <option value={code.id} key={'type-' + code.id} >{code.typeName}</option>;
								})
							}
						</select>
						<br />
						<br />
						<br />
						<label 
							htmlFor='publicationEventInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Publication/Event
						</label>
						<input 
							id='publicationEventInput'
							type='text'
							maxLength={200}
							value={this.state.publicationEvent}
							onChange={this.handlePublicationEventChange}
							disabled={!canEdit}
						/>
						<br />
						<br />
						<label 
							htmlFor='siteIdsInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Post
						</label>
						{
							this.state.allSitesList.map((site) => {
								return (
									<div key={'site-' + site.id} style={{ whiteSpace: 'nowrap', display: 'inline'}} >
										<input 
											type='checkbox'
											name='siteIdsInput'
											id={site.id}
											checked={this.state.sites.includes(site.id)} 
											onChange={this.handleSiteOptionChange}
											disabled={ 
												(this.props.activeOrg != site.organizationId) || // eslint-disable-line eqeqeq
												(this.state.tracking === 'true' 
												|| (
													this.state.share === 'false' 
													&& this.state.OrgSitesList.filter((orgSite) => orgSite.id === site.id).length < 1
												))
											}
										/>
										<label htmlFor={site.id} style={{ paddingLeft: 5, wordWrap: 'anywhere' }}>{
											site.url
												? site.url  // Default to URL
												: site.name
													? site.name // Fall back to name
													: 'Page #' + site.id // Last resort is the id
										}</label>
										<br />
									</div>
								);
							})
						}
					</div>
					<div className='column column-four'>
						<label 
							htmlFor='abstractInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Abstract {requiredStar} 
						</label>
						
						<input 
							type='radio' 
							id='Yes' 
							name='abstractInput' 
							value='Yes'
							checked={this.state.showAbstractBox}
							onChange={this.handleAbstractOptionChange} 
							disabled={!canEdit}
						/>
						<label htmlFor='Yes'>Yes</label>
						
						<input  
							type='radio'  
							id='No'  
							name='abstractInput'  
							value='No' 
							checked={!this.state.showAbstractBox}
							onChange={this.handleAbstractOptionChange} 
							disabled={!canEdit}
						/>
						<label htmlFor='No'>No</label>
						
						<br />
						
						<textarea 
							type='text' 
							onChange={this.handleAbstractValueChange} 
							style={{ width: '100%', height: '80px' }} 
							maxLength={10000} 
							placeholder='Enter Abstract'
							value={this.state.abstractText}
							hidden={!this.state.showAbstractBox}
							disabled={!canEdit}
						/>
						<br />
						<br />
						<label 
							htmlFor='artifactInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Artifact Link {requiredStar} 
						</label>
						
						<input 
							type='radio' 
							id='Yes' 
							name='artifactInput' 
							value='Yes'
							checked={this.state.showArtifactBox}
							onChange={this.handleArtifactOptionChange}
							disabled={!canEdit}
						/>
						<label htmlFor='Yes'>Yes</label>
						
						<input  
							type='radio'  
							id='No'  
							name='artifactInput'  
							value='No' 
							checked={!this.state.showArtifactBox}
							onChange={this.handleArtifactOptionChange} 
							disabled={!canEdit}
						/>
						<label htmlFor='No'>No</label>
						
						<br />
						
						<input
							type='text'
							hidden={!this.state.showArtifactBox}
							maxLength={200}
							value={this.state.artifactUrl || ''}
							onChange={this.updateArtifactUrl}
							disabled={!canEdit}
						/>
						
						<br />
						<br />
						<label 
							htmlFor='originInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Origin {requiredStar} 
						</label>
						<input 
							type='radio' 
							id='Internal' 
							name='originInput' 
							value='Internal'
							checked={this.state.origin === 'Internal'}
							onChange={this.handleOriginOptionChange} 
							disabled={!canEdit}
						/>
						<label htmlFor='Internal'>Internal</label>
						
						<input  
							type='radio'  
							id='External'  
							name='originInput'  
							value='External' 
							checked={this.state.origin === 'External'}
							onChange={this.handleOriginOptionChange} 
							disabled={!canEdit}
						/>
						<label htmlFor='External'>External</label>
						<br />
						<br />
						<label 
							htmlFor='shareInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Share {requiredStar} 
						</label>
							<input 
								type='radio' 
								id='yes' 
								name='shareInput' 
								value='true'
								checked={this.state.share === 'true'}
								onChange={this.handleShareOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='yes'>Yes</label>
							
							<input  
								type='radio'  
								id='no'  
								name='shareInput'  
								value='false'
								checked={this.state.share === 'false'}
								onChange={this.handleShareOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='no'>No</label>
						<br />
						<br />
						<label 
							htmlFor='trackingInput' 
							style={{display: 'block'}}
							className='edit-pub-label'
						>
							Tracking Only {requiredStar} 
						</label>
							<input 
								type='radio' 
								id='yes' 
								name='trackingInput' 
								value='true'
								checked={this.state.tracking === 'true'}
								onChange={this.handleTrackingOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='yes'>Yes</label>
							
							<input  
								type='radio'  
								id='no'  
								name='trackingInput'  
								value='false'
								checked={this.state.tracking === 'false'}
								onChange={this.handleTrackingOptionChange} 
								disabled={!canEdit}
							/>
							<label htmlFor='no'>No</label>
							<br />
							<span 
								hidden={this.state.tracking === 'false'} 
								className='edit-pub-tracking-text' 
							>
								Won't be posted to any websites
							</span>
					</div>
					
				</div>
				{this.state.editPubModal}
				<div className='edit-pub-button-container'>
					<div 
						className='edit-pub-button clickable'
						onClick={this.verifySubmit}
					>
						Save
					</div>
				</div>
			</div>
		);
	}
}
export default EditPubPage;